<template>
    <div>
        <div>
            <fieldset>
                <div class="row">
                    <legend>Wearer Information</legend>
                </div>
            </fieldset>
        </div>
        <div class="row">
            <div class="column small-12 medium-12">
                <div class="row">
                    <div class="columns small-4 medium-2 "> Name:</div>
                    <div class="columns small-8 medium-10"> {{sampleobject.firstName}} {{sampleobject.lastName}}</div>
                </div>
            </div>
            <div class="column small-12 medium-12">
                <div class="row">
                    <div class="columns small-4 medium-2 "> Practice: </div>
                    <div class="columns small-8 medium-10"> {{sampleobject.practiceName}}</div>
                </div>
            </div>
            <div class="column small-12 medium-12">
                <div class="row">
                    <div class="columns small-4  medium-2 "> Role: </div>
                    <div class="columns small-8 medium-10"> {{sampleobject.role}}</div>
                </div>
            </div>
            <div class="column small-12 medium-12" v-if="program &&  program.freeEntry1Label">
                <div class="row">
                    <div class="columns small-4 medium-2"> {{program.freeEntry1Label}}: </div>
                    <div class="columns small-8 medium-10"> {{sampleobject.freeEntry1}} </div>
                </div>
            </div>
             <div class="column small-12 medium-12" v-if="program && program.freeEntry2Label">
                <div class="row">
                    <div class="columns small-4 medium-2">{{program.freeEntry2Label}}: </div>
                    <div class="columns small-8 medium-10">  {{sampleobject.freeEntry2}} </div>
                </div>
            </div>
             <div class="column small-12 medium-12" v-if="program && program.freeEntry3Label">
                <div class="row">
                    <div class="columns small-4 medium-2">{{program.freeEntry3Label}}:</div>
                    <div class="columns small-8 medium-10">  {{sampleobject.freeEntry3}} </div>
                </div>
            </div>
             <div class="column small-12 medium-12" v-if="program && program.freeEntry4Label">
                <div class="row">
                    <div class="columns small-4 medium-2"> {{program.freeEntry4Label}}:</div>
                    <div class="columns small-8 medium-10">  {{sampleobject.freeEntry4}} </div>
                </div>
            </div>
                <div class="column small-12 medium-12" v-if="program && program.freeEntry5Label">
                <div class="row">
                    <div class="columns small-4 medium-2">  {{program.freeEntry5Label}}: </div>
                    <div class="columns small-8 medium-10">  {{sampleobject.freeEntry5}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  props: ["sampleobject", "program"]
};
</script>
<style>
.frame-review-section {
  margin-top: 15px;
}
</style>
